import { useRef } from "react";
import ArrowTop from "../../Common/svg/arrowtop";
import SkeletonWrapper from "../../UI/skeletonWrapper";

const UploadImages = ({
  handleChange,
  formData,
  errorMessage,
  storeData,
  mode,
  isLoading,
}) => {
  console.log("errorMessage", errorMessage);
  const coverInputRef = useRef(null);
  const logoInputRef = useRef(null);
  console.log('storeData.cover_image', storeData?.cover_image)
  const handleUploadClick = (ref) => {
    ref.current.click();
  };

  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
const ALLOWED_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/svg+xml",
];
  return (
    <div className="row justify-content-between mt-3">
      {/* Logo Upload */}
      <div className="col-md-6">
          <h5 className="form-label">صورة اللوجو</h5>
      <div
        className="flex-grow-1 border rounded-4 text-center p-4 upload-box "
        onClick={() => handleUploadClick(logoInputRef)}
        style={{ cursor: "pointer", minWidth: "250px" }}
      >
    { formData?.logo ?null: <>
     <ArrowTop />
        <h6 className="fw-bold mb-1">تحميل صورة اللوجو</h6>
        <p className="text-muted small mb-0">
          (JPG / PNG) ارفع صورة بجودة عالية
        </p>
        <p className="text-muted small mb-0">الأبعاد 1:1</p>
    </> }
        <SkeletonWrapper isLoading={isLoading}>
          <input
            type="file"
            name="logo"
           accept=".jpg,.jpeg,.png,.gif,.svg" 
            ref={logoInputRef}
            hidden
            onChange={handleChange}
          />
        </SkeletonWrapper>
        {formData?.logo && formData?.logo?.name}
        <div>   {formData?.logo && <img className="square" src={
                  formData.logo instanceof File
                    ? URL.createObjectURL(formData.logo)
                    : formData.logo
                }alt="logo" />}</div>
      </div>
      
      {errorMessage["store.logo"] && (
        <div className="text-danger">
          {errorMessage && errorMessage["store.logo"][0]}
        </div>
      )}
      </div>
      


      {/* Cover Upload */}  
      <div className="col-md-6">
 <h5 className="form-label">صورة الغلاف</h5>
      <div
        className="flex-grow-1 border rounded-4 text-center p-4 upload-box  "
        onClick={() => handleUploadClick(coverInputRef)}
        style={{ cursor: "pointer", minWidth: "250px" }}
      > 
 
    {formData?.cover_image ?null :  <>        <ArrowTop /> <h6 className="fw-bold mb-1">تحميل صورة الغلاف</h6>
        <p className="text-muted small mb-0">
          (JPG / PNG) ارفع صورة بجودة عالية
        </p>
        <p className="text-muted small mb-0">الأبعاد 16:9</p></>  }
        <SkeletonWrapper isLoading={isLoading}>
          <input
            type="file"
            name="cover_image"
        accept=".jpg,.jpeg,.png,.gif,.svg" 
            ref={coverInputRef}
            hidden
            onChange={handleChange}
            className="wide"
          />
        </SkeletonWrapper>
        {formData?.cover_image && formData?.cover_image?.name}
        <div>   
          {formData?.cover_image && <img    src={
                  formData.cover_image instanceof File
                    ? URL.createObjectURL(formData.cover_image)
                    : formData.cover_image
                }alt="cover_image" />}
        </div>
      </div>
      {errorMessage["store.cover_image"] && (
        <small className="text-danger">
          {errorMessage && errorMessage["store.cover_image"][0]}
        </small>
      )}
      </div>
    
    </div>
  );
};

export default UploadImages;
